export default {
    unique(arr, property) {
        return arr.filter((value, index, self) =>
            index === self.findIndex((t) => (
            t[property] === value[property]
        )));
    }
};


// WEBPACK FOOTER //
// ./src/helpers/helpers.js